import { stateLabel } from "../state-label";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";

export function describeToolSearch(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const query = toolInput.trimmed(record.query);
  if (!query?.startsWith("select:")) {
    const target = query
      ? `the tools for "${toolInput.truncate(query, 60)}"`
      : "the available tools";
    return stateLabel(state, {
      done: `Searched ${target}`,
      running: `Searching ${target}`,
      failed: `Could not search ${target}`,
    });
  }
  const names = query
    .slice("select:".length)
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean);
  const target =
    names.length === 1
      ? `the ${toolInput.truncate(names[0] ?? "", 60)} tool`
      : `${names.length} tools`;
  return stateLabel(state, {
    done: `Loaded ${target}`,
    running: `Loading ${target}`,
    failed: `Could not load ${target}`,
  });
}
